import type { HTMLAttributes } from "react";

import { cn } from "../../utils";

const Separator = ({ className, ...props }: HTMLAttributes<HTMLSpanElement>) => {
  return (
    <span {...props} className={cn("-mt-1.5 text-6xl leading-3 font-medium text-neutral-80", className)}>
      -
    </span>
  );
};

export default Separator;
